// extracted by mini-css-extract-plugin
export var treatmentCard = "PromotedTreatment-module--treatmentCard--51762";
export var treatmentCardContent = "PromotedTreatment-module--treatmentCardContent--ae5c2";
export var treatmentCardImage = "PromotedTreatment-module--treatmentCardImage--57607";
export var treatmentCardTitle = "PromotedTreatment-module--treatmentCardTitle--78f7f";